import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

const UpdateRenewableEnergy = () => {
  const { id } = useParams();

  const [formData, setFormData] = useState({
    renergy_name: "",
    renergy_address: "",
    renergy_city: "",
    renergy_district: "",
    renergy_state: "",
    renergy_pincode: "",
    renergy_phone: "",
    renergy_email: "",
    renergy_website: "",
  });

  const [errors, setErrors] = useState({});
  const [submissionStatus, setSubmissionStatus] = useState("");

  useEffect(() => {
    const fetchPlantData = async () => {
      try {
        const res = await fetch(`https://backend-zkgn.onrender.com/api/renewableplants/${id}`);
        const data = await res.json();
        if (data) setFormData(data);
      } catch (err) {
        console.error("Error fetching plant data:", err);
      }
    };
    fetchPlantData();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const validateForm = () => {
    const tempErrors = {};
    if (!formData.renergy_name) tempErrors.renergy_name = "Plant name is required.";
    if (!formData.renergy_address) tempErrors.renergy_address = "Address is required.";
    if (!formData.renergy_city) tempErrors.renergy_city = "City is required.";
    if (!formData.renergy_district) tempErrors.renergy_district = "District is required.";
    if (!formData.renergy_state) tempErrors.renergy_state = "State is required.";
    if (!formData.renergy_pincode) tempErrors.renergy_pincode = "Pincode is required.";
    if (!formData.renergy_email) tempErrors.renergy_email = "Email is required.";
    if (!formData.renergy_website) tempErrors.renergy_website = "Website is required.";
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const response = await fetch(`https://backend-zkgn.onrender.com/api/renewableplants/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSubmissionStatus("Renewable Energy Plant updated successfully!");
      } else {
        setSubmissionStatus("Failed to update Renewable Energy Plant.");
      }
    } catch (error) {
      console.error("Error updating form:", error);
      setSubmissionStatus("An error occurred while updating the form.");
    }
  };

  return (
    <div className="container mt-4">
      <h3 className="mb-4">Update Renewable Energy Plant</h3>
      {submissionStatus && <div className="alert alert-info">{submissionStatus}</div>}

      <form onSubmit={handleSubmit}>
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label">Plant Name</label>
            <input
              type="text"
              className="form-control"
              name="renergy_name"
              value={formData.renergy_name}
              onChange={handleChange}
            />
            {errors.renergy_name && <div className="text-danger">{errors.renergy_name}</div>}
          </div>

          <div className="col-12">
            <label className="form-label">Address</label>
            <textarea
              className="form-control"
              name="renergy_address"
              rows="2"
              value={formData.renergy_address}
              onChange={handleChange}
            ></textarea>
            {errors.renergy_address && <div className="text-danger">{errors.renergy_address}</div>}
          </div>

          <div className="col-md-6">
            <label className="form-label">City</label>
            <input
              type="text"
              className="form-control"
              name="renergy_city"
              value={formData.renergy_city}
              onChange={handleChange}
            />
            {errors.renergy_city && <div className="text-danger">{errors.renergy_city}</div>}
          </div>

          <div className="col-md-6">
            <label className="form-label">District</label>
            <input
              type="text"
              className="form-control"
              name="renergy_district"
              value={formData.renergy_district}
              onChange={handleChange}
            />
            {errors.renergy_district && <div className="text-danger">{errors.renergy_district}</div>}
          </div>

          <div className="col-md-6">
            <label className="form-label">State</label>
            <input
              type="text"
              className="form-control"
              name="renergy_state"
              value={formData.renergy_state}
              onChange={handleChange}
            />
            {errors.renergy_state && <div className="text-danger">{errors.renergy_state}</div>}
          </div>

          <div className="col-md-6">
            <label className="form-label">Pincode</label>
            <input
              type="text"
              className="form-control"
              name="renergy_pincode"
              value={formData.renergy_pincode}
              onChange={handleChange}
            />
            {errors.renergy_pincode && <div className="text-danger">{errors.renergy_pincode}</div>}
          </div>

          <div className="col-md-4">
            <label className="form-label">Phone</label>
            <input
              type="text"
              className="form-control"
              name="renergy_phone"
              value={formData.renergy_phone}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-4">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-control"
              name="renergy_email"
              value={formData.renergy_email}
              onChange={handleChange}
            />
            {errors.renergy_email && <div className="text-danger">{errors.renergy_email}</div>}
          </div>

          <div className="col-md-4">
            <label className="form-label">Website</label>
            <input
              type="url"
              className="form-control"
              name="renergy_website"
              value={formData.renergy_website}
              onChange={handleChange}
            />
            {errors.renergy_website && <div className="text-danger">{errors.renergy_website}</div>}
          </div>
        </div>

        <div className="mt-4">
          <button type="submit" className="btn btn-success">Update</button>
        </div>
      </form>
    </div>
  );
};

export default UpdateRenewableEnergy;
